import { UISimulation } from '@/components/help/UISimulation';
import { SimShell } from './simShell';

const D = 1900;

// Component packs — 3 frames: settings -> toggle packs -> toolbar updates.
function CPSettings(): JSX.Element {
  return (
    <SimShell step={1} total={3} title="Components tab">
      <ul className="space-y-1 text-xs">
        {[
          ['core', 'always on', true],
          ['medical', 'on', true],
          ['finance', 'off', false],
          ['food', 'off', false],
        ].map(([name, state, on]) => (
          <li
            key={String(name)}
            className="flex items-center justify-between rounded border border-dash-border bg-dash-surface px-3 py-1.5"
          >
            <span className="text-dash-primary">{name}</span>
            <span
              className={
                'font-mono text-[10px] uppercase ' + (on ? 'text-success' : 'text-dash-muted')
              }
            >
              {state}
            </span>
          </li>
        ))}
      </ul>
    </SimShell>
  );
}

function CPToggle(): JSX.Element {
  return (
    <SimShell step={2} total={3} title="Toggle a pack">
      <div className="flex items-center justify-between rounded border border-accent/40 bg-accent/10 px-3 py-2 text-xs">
        <span className="text-dash-primary">finance</span>
        <span className="font-mono text-[10px] uppercase text-accent">turning on…</span>
      </div>
      <div className="mt-1.5 text-[10px] font-mono text-warning">
        disabling a pack with in-use shorthand warns you first
      </div>
    </SimShell>
  );
}

function CPToolbar(): JSX.Element {
  return (
    <SimShell step={3} total={3} title="Editor toolbar updates">
      <div className="flex flex-wrap gap-1.5 text-[11px]">
        {['FAQ', 'Study', 'Stat', 'Compare', 'RateTable', 'FeeBox'].map((c, i) => (
          <span
            key={c}
            className={
              'rounded px-2 py-0.5 border ' +
              (i >= 4
                ? 'border-accent/40 bg-accent/10 text-accent'
                : 'border-dash-border bg-dash-surface text-dash-secondary')
            }
          >
            {c}
          </span>
        ))}
      </div>
      <div className="mt-1.5 text-[10px] font-mono text-dash-muted">
        new pack adds its shorthand to + Component
      </div>
    </SimShell>
  );
}

export function ComponentPackSimulation(): JSX.Element {
  return (
    <UISimulation
      steps={[
        { frame: <CPSettings />, label: 'Packs live on the Components tab', duration: D },
        { frame: <CPToggle />, label: 'Toggle a pack on', duration: D },
        { frame: <CPToolbar />, label: 'New shorthand appears in the editor', duration: D },
      ]}
    />
  );
}
